import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { Auth } from "aws-amplify";
import Badge from "react-bootstrap/Badge";
import "./../../assets/css/navbar.css";
import { HTTPService } from "./../../services/httpService";
import packageJSON from "../../../package.json";
import JobviousLogo from "./../../assets/Jobvious_white_logo_base.svg";

const API = new HTTPService();

class navBar extends Component {
  doSubmit = async () => {
    Auth.signOut()
      .then(() => {
        localStorage.clear();
        this.props.history.push("/login");
      })
      .catch((err) => {
        //console.log(err);
      });
  };

  state = {
    countsReturned: [], // Keep for backward compatibility
    requestCount: 0,
    jobCount: 0,
    pickupCount: 0,
    referralCount: 0,
    loading: true,
    error: null,
    // NEW: Calendar selection state
    isCalendarConnected: false,
    campaignsOpen: false, // NEW: Campaigns submenu state
    // Stripe connection state
    isStripeConnected: false,

  };

  async componentDidMount() {
    
    try {
      // 🚀 OPTIMIZED: Single API call for all navbar data
      await this.loadOptimizedNavbarData();
    } catch (error) {
      console.error('Optimized navbar loading failed, falling back to legacy method:', error);
      // 🔧 FALLBACK: Use original method if new endpoint fails
      await this.loadNavbarDataLegacy();
    }
      // Check calendar and Stripe connection status for installers
  if (this.props.userType === "installer") {
    await this.checkCalendarStatus();
    await this.checkStripeStatus();
  }

  // Listen for calendar status changes
  window.addEventListener('calendarStatusChanged', this.handleCalendarStatusChange);
  }

  componentDidUpdate(prevProps) {
  console.log('🔄 Navbar props changed:', {
    oldEntityId: prevProps.entityId,
    newEntityId: this.props.entityId,
    entityIdChanged: prevProps.entityId !== this.props.entityId
  });
  
  if (prevProps.entityId !== this.props.entityId) {
    console.log('🆔 EntityId changed, should refresh navbar data');
    // We need to refresh data here
  }
}

  componentWillUnmount() {
  window.removeEventListener('calendarStatusChanged', this.handleCalendarStatusChange);
}
// Add this method
handleCalendarStatusChange = (event) => {
  this.setState({ 
    isCalendarConnected: event.detail.connected 
  });
};

// Add this method
checkCalendarStatus = async () => {
  try {
    const response = await API.get(`/installerAuth/${this.props.entityId}`);

    if (response.data && response.data[0]) {
      const { authenticated, calendar_id } = response.data[0];
      this.setState({
        isCalendarConnected: authenticated && !!calendar_id
      });
    }
  } catch (error) {
    console.error('Error checking calendar status in navbar:', error);
    // Don't set error state - just leave as disconnected
  }
};

// Check Stripe connection status
checkStripeStatus = async () => {
  try {
    const response = await API.get(`/installers/${this.props.entityId}`);

    if (response.data && response.data[0]) {
      const { stripe_account_id, onboarding_complete } = response.data[0];
      this.setState({
        isStripeConnected: !!stripe_account_id && !!onboarding_complete
      });
    }
  } catch (error) {
    console.error('Error checking Stripe status in navbar:', error);
    // Don't set error state - just leave as disconnected
  }
};

  // 🚀 NEW: Optimized single API call method
  loadOptimizedNavbarData = async () => {
    console.log('🚀 Loading optimized navbar data...');
    const start = performance.now();

    try {
      // Single API call with all required parameters
      const navbarRequest = `/navbar-data-cached?entityId=${this.props.entityId}&userId=${this.props.userId}&userType=${this.props.userType}&access=${this.props.access || 'STANDARD'}`;
      
      const { data: navbarData } = await API.get(navbarRequest);
      
      const loadTime = Math.round(performance.now() - start);
      console.log(`✅ Navbar data loaded in ${loadTime}ms:`, navbarData);

      // Update state with all the data from single call
      this.setState({
        requestCount: navbarData.requestCount || 0,
        jobCount: navbarData.jobCount || 0,
        pickupCount: navbarData.pickupCount || 0,
        referralCount: navbarData.referralCount || 0,
        authenticated: navbarData.authenticated || false,
        calendar: navbarData.calendar || "",
        isStripeConnected: navbarData.stripeConnected || false,
        loading: false,
        error: null,
        countsReturned: [] // No longer needed but keep for compatibility
      });

    } catch (error) {
      console.error('❌ Optimized navbar loading failed:', error);
      this.setState({ error: error.message, loading: false });
      throw error; // Re-throw to trigger fallback
    }
  };

  // 🔧 FALLBACK: Original method (kept for backward compatibility)
  loadNavbarDataLegacy = async () => {
    console.log('🔄 Loading navbar data using legacy method...');
    const start = performance.now();

    try {
      // Original logic - multiple API calls
      let countRequest = `/counts/?userId=${this.props.entityId}&userType=${this.props.userType}`;
      
      const { data: countsReturned } = await API.get(countRequest);
      this.setState({ countsReturned });

      // Handle referrals for dealers
      if (this.props.userType === "dealer" && this.props.access !== "DIRECT") {
        let referralRequest = `/referralcounts/?userId=${this.props.userId}&userType=${this.props.userType}`;
        const { data: referralsReturned } = await API.get(referralRequest);
        if (referralsReturned.length > 0) {
          let fullCountsReturned = countsReturned.concat(referralsReturned);
          this.setState({ countsReturned: fullCountsReturned });
        }
      }

      // Process counts into state (original logic)
      var requestCount = 0;
      var jobCount = 0;
      var pickupCount = 0;
      var referralCount = 0;

      for (var i = 0; i < this.state.countsReturned.length; i++) {
        switch (this.state.countsReturned[i].current_state) {
          case "referrals":
            referralCount = referralCount + this.state.countsReturned[i].total;
            break;
          case "new":
            requestCount = requestCount + this.state.countsReturned[i].total;
            break;
          case "answered":
            requestCount = requestCount + this.state.countsReturned[i].total;
            break;
          case "scheduled":
            jobCount = jobCount + this.state.countsReturned[i].total;
            break;
          case "received":
            jobCount = jobCount + this.state.countsReturned[i].total;
            break;
          case "started":
            jobCount = jobCount + this.state.countsReturned[i].total;
            break;
          case "finished":
            pickupCount = pickupCount + this.state.countsReturned[i].total;
            break;
          default:
            break;
        }
        if (
          this.props.userType === "dealer" &&
          this.state.countsReturned[i].current_state === "collected"
        ) {
          pickupCount = pickupCount + this.state.countsReturned[i].total;
        }
      }

      this.setState({ 
        requestCount, 
        jobCount, 
        pickupCount, 
        referralCount,
        loading: false,
        error: null
      });

      const loadTime = Math.round(performance.now() - start);
      console.log(`✅ Legacy navbar data loaded in ${loadTime}ms`);

    } catch (error) {
      console.error('❌ Legacy navbar loading also failed:', error);
      this.setState({ 
        error: error.message, 
        loading: false,
        // Set safe defaults to prevent UI breakage
        requestCount: 0,
        jobCount: 0,
        pickupCount: 0,
        referralCount: 0,
        authenticated: false,
        calendar: ""
      });
    }
  };

  // 🔧 LEGACY: Keep original readAuth method for fallback
  readAuth = async (installerId) => {
    let installerRequest = `/installerAuth/${installerId}`;
    const { data: installer } = await API.get(installerRequest);
    this.setState({
      authenticated: installer[0].authenticated,
      calendar: installer[0].calendar_id,
    });
  };

  navigate = async (url) => {
    window.location.href = url;
  };

  authorizeGoogle = async () => {
    // send this key to the back end to get the tokens and store them with the installer
    let userSetup = `/request`;
    const { data: creds } = await API.get(userSetup);
    this.navigate(creds);
  };

  // NEW: Toggle campaigns submenu
  toggleCampaigns = () => {
    this.setState({ campaignsOpen: !this.state.campaignsOpen });
  };

  // 🎯 NEW: Manual refresh method for testing
  refreshNavbarData = () => {
    this.setState({ loading: true });
    this.loadOptimizedNavbarData().catch(() => {
      this.loadNavbarDataLegacy();
    });
  };

  render() {
    // Show loading state
    if (this.state.loading) {
      return (
        <React.Fragment>
          <div className="main-sidebar bg-primary-orange">
            <div className="d-flex align-items-center justify-content-center">
              <img
                src={JobviousLogo}
                alt="Jobvious"
                width="200px"
                className="mb-5 mt-5"
              />
            </div>
            <div className="text-center text-light">
              <small>Loading...</small>
            </div>
          </div>
        </React.Fragment>
      );
    }

    // Show error state
    if (this.state.error) {
      return (
        <React.Fragment>
          <div className="main-sidebar bg-primary-orange">
            <div className="d-flex align-items-center justify-content-center">
              <img
                src={JobviousLogo}
                alt="Jobvious"
                width="200px"
                className="mb-5 mt-5"
              />
            </div>
            <div className="text-center text-light">
              <small>Error loading menu</small>
              <button 
                className="btn btn-sm btn-light mt-2"
                onClick={this.refreshNavbarData}
              >
                Retry
              </button>
            </div>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className="main-sidebar bg-primary-orange">
          <div className="d-flex align-items-center justify-content-center">
            <img
              src={JobviousLogo}
              alt="Jobvious"
              width="200px"
              className="mb-3 mt-3"
            />
          </div>

          <ul>
            {((this.props.userType === "dealer" && this.props.access !== "DIRECT") || this.props.userType === "installer") && (
              <li>
                <NavLink
                  activeClassName="active"
                  className="text-light"
                  to="/referrals"
                >
                  {this.state.referralCount > 0 && (
                    <Badge pill variant="danger">
                      {this.state.referralCount}
                    </Badge>
                  )}{" "}
                  Referrals
                </NavLink>
              </li>
            )}
            <li>
              <NavLink
                activeClassName="active"
                className="text-light"
                to={{ pathname: "/requestimates", selectedRequestimate: {} }}
              >
                {this.state.requestCount > 0 && (
                  <Badge pill variant="danger">
                    {this.state.requestCount}
                  </Badge>
                )}{" "}
                Requestimates
              </NavLink>
            </li>
            <li>
              <NavLink
                activeClassName="active"
                className="text-light"
                to={{ pathname: "/jobs", selectedRequestimate: {} }}
              >
                {this.state.jobCount > 0 && (
                  <Badge pill variant="danger">
                    {this.state.jobCount}
                  </Badge>
                )}{" "}
                Jobs
              </NavLink>
            </li>
            {this.props.userType === "dealer" && (
              <li>
                <NavLink
                  activeClassName="active"
                  className="text-light"
                  to="/pickups"
                >
                  {this.state.pickupCount > 0 && (
                    <Badge pill variant="danger">
                      {this.state.pickupCount}
                    </Badge>
                  )}{" "}
                  Pickup/Review
                </NavLink>
              </li>
            )}
            {this.props.userType === "installer" && (
              <li>
                <NavLink
                  activeClassName="active"
                  className="text-light"
                  to="/pickups"
                >
                  {this.state.pickupCount > 0 && (
                    <Badge pill variant="danger">
                      {this.state.pickupCount}
                    </Badge>
                  )}{" "}
                  Pickup/Deliver
                </NavLink>
              </li>
            )}
            {this.props.userType === "installer" && (
              <li>
                <NavLink
                  activeClassName="active"
                  className="text-light"
                  to="/calendar"
                >
                  {!this.state.isCalendarConnected && (
                    <>
                      <span className="calendar-warning-icon" title="Calendar Not Connected">⚠️</span>{" "}
                    </>
                  )}
                  Calendar
                </NavLink>
              </li>
            )}
            <li>
              <NavLink
                activeClassName="active"
                className="text-light"
                to="/financials"
              >
                Financials
              </NavLink>
            </li>

            {this.props.userType === "installer" && (
              <>
                <li>
                  <div
                    className={`text-light campaigns-parent ${
                      window.location.pathname === '/campaigns' ? 'active' : ''
                    }`}
                    onClick={this.toggleCampaigns}
                    style={{ cursor: 'pointer', padding: '10px 15px' }}
                  >
                    Automations
                    <span className={`chevron ${this.state.campaignsOpen ? 'open' : ''}`}>
                      ▼
                    </span>
                  </div>
                </li>
                {this.state.campaignsOpen && (
                  <>
                    <li className="submenu-item">
                      <NavLink
                        activeClassName="active"
                        className="text-light"
                        to="/campaigns?agent=iris"
                      >
                        Iris – Customer Experience
                      </NavLink>
                    </li>
                    <li className="submenu-item">
                      <NavLink
                        activeClassName="active"
                        className="text-light"
                        to="/campaigns?agent=luke"
                      >
                        Luke – Re-Engagement
                      </NavLink>
                    </li>
                  </>
                )}
              </>
            )}
            {this.props.userType === "installer" && (
              <li>
                <NavLink
                  activeClassName="active"
                  className="text-light"
                  to="/customers"
                >
                  Customers
                </NavLink>
              </li>
            )}
            {this.props.userType === "installer" && (
              <li>
                <NavLink
                  activeClassName="active"
                  className="text-light"
                  to="/services"
                >
                  Services
                </NavLink>
              </li>
            )}
            {this.props.userType === "installer" && (
              <li>
                <NavLink
                  activeClassName="active"
                  className="text-light"
                  to="/vehicles"
                >
                  Vehicles
                </NavLink>
              </li>
            )}
            {this.props.userType === "installer" && (
              <li>
                <NavLink
                  activeClassName="active"
                  className="text-light"
                  to="/profile"
                >
                  {!this.state.isStripeConnected && (
                    <>
                      <span className="stripe-warning-icon" title="Payment Setup Required">⚠️</span>{" "}
                    </>
                  )}
                  Profile
                </NavLink>
              </li>
            )}

            {this.props.access === "ADMIN" && (
              <li>
                <NavLink
                  activeClassName="active"
                  className="text-light"
                  to="/users"
                >
                  User Management
                </NavLink>
              </li>
            )}
            {this.props.userType === "dealer" && (
              <li>
                <a
                  className="text-light"
                  href="https://www.jobvious.com/dealer-support-page"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  System Help
                </a>
              </li>
            )}
            {this.props.userType === "installer" && (
              <li>
                <a
                  className="text-light"
                  href="https://www.jobvious.com/specialist-support-page"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  System Help
                </a>
              </li>
            )}
          </ul>

          <div className="mt-5 mb-5 text-center">
            <button
              className="btn btn-success btn-primary-green rounded-pill"
              onClick={this.doSubmit}
            >
              Sign Out
            </button>
          </div>
          
          {/* 🔧 DEBUG: Show performance info in development */}
          {process.env.NODE_ENV === 'development' && (
            <div className="version text-center text-light">
              <small>
                R:{this.state.requestCount} J:{this.state.jobCount} P:{this.state.pickupCount}
              </small>
            </div>
          )}
          
          <div className="version text-center text-light">
            v {packageJSON.version}
          </div>
          <div className="version text-center">
            <a
              className="text-light"
              href="https://s3.us-east-2.amazonaws.com/jobvious.digitalassets/Jobvious_Release_Notes.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Release Notes
            </a>
          </div>
          <div className="version text-center">
            <a
              className="text-light"
              href="https://s3.us-east-2.amazonaws.com/jobvious.digitalassets/Jobvious.Privacy.Policy.10.6.21.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </div>
          <div className="version text-center">
            <a
              className="text-light"
              href="https://s3.us-east-2.amazonaws.com/jobvious.digitalassets/Jobvious.Limited.Use.Policy.7.10.24.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google API Policy
            </a>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(navBar);